import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import { IEquipment } from 'interfaces';
import EquipmentForm from '../EquipmentForm';
import { useCreateEquipment } from '../hooks';

const initEquipment: IEquipment = {
  id: null,
  code: '',
  description: '',
  workstation: null,
  status: null
};

export const CreateEquipment = () => {
  const { t } = useTranslation();
  const { onSubmit } = useCreateEquipment();

  const translationPrefix = 'pages.equipment.new';

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EquipmentForm equipment={initEquipment} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateEquipment;
